/**
 * Trimmed lowercase form of `query`; coerces number inputs to their string form,
 * and returns '' for null/undefined. Shared between autocomplete widgets so
 * their input normalization stays identical.
 */
export function normalizeQuery(query: string | number | null | undefined): string {
  if (query === null || query === undefined) return '';
  return String(query).trim().toLowerCase();
}
